<!--
 * @Descripttion: 
 * @version: 
 * @Author: A21
 * @Date: 2022-05-27 13:16:54
 * @LastEditors: A21
 * @LastEditTime: 2022-05-31 12:00:02
 * @FilePath: /intell-loan/src/views/pages/otherPage/successfulCreditExtension.vue
-->
<template>
  <div class="bg">
    <div class="content">
      <img
        class="success"
        src="@/assets/images/success.png"
        alt="成功"
      />
      <p class="tip">征信授权书签署成功</p>
    <div class="nextStepBox">
      <Button
        :loading="loading"
        loadingText="加载中..."
        type="danger"
        text="下一步"
        :disabled="isDisabled"
        class="nextStep"
        :click="nextStep"
      />
    </div>
    </div>
  </div>
</template>
<script>
import Button from '@/components/Button.vue';
import { Toast } from 'vant';
import { mapState } from 'vuex';

export default {
  name: 'successfulCreditExtension',
  components: {
    Button,
  },
  data() {
    return {
      isDisabled: false,
    };
  },
  mounted() {
  },
  methods: {
    nextStep() {
      this.isDisabled = true;
      const { orderId } = this.$route.query;
      this.$api.CommonForms.nextJumpPageServer({
        orderId: orderId || localStorage.getItem('orderId'),
      }).then((res) => {
        if (res.success && res.data) {
          window.location.href = res.data;
        } else {
          Toast(res.returnMessage);
        }
        this.isDisabled = false;
      }).catch((e) => {
        Toast('系统异常，请稍后再试');
        this.isDisabled = false;
      });
    },
  },
  computed: {
    ...mapState({
      commonForms(val) {
        return val.commonForms;
      },
    }),
  },

};
</script>
<style scoped>
/* 提款审批中 */
.content {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 60px 0;
  color: #a6a6a6;
  box-sizing: border-box;
}

.content .success {
  width: 60px;
  height: 60px;
}

.content p:nth-child(2) {
  font-size: 16px;
  font-weight: bold;
  margin: 30px 0;
}

.content p:nth-child(3) {
  font-size: 14px;
  text-align: left;
}
.bg {
  width: 100%;
  height: 100%;
  background: #fff;
}
.nextStepBox{
  width: 100%;
  margin-top: 90px;
}
.tip {
  color: #1c2438;
  font-size: 17px;
  text-align: center;
}
</style>
